<template>
  <div>
    <lf-button
      data-cy="run-backtest-report-button"
      class="h-10 border border-gray-200 bg-white text-primary hover:bg-gray-100"
      :disabled="!applicationIds.length"
      @click="redirectToBacktestReport"
    >
      <slot name="icon">
        <icon-base
          :icon="IconPercentage"
          view-box="0 0 16 16"
          class="mr-2 h-4 w-4"
        />
      </slot>
      {{ $t("SCORECARDS.RUN_BT_REPORT") }}
    </lf-button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useNotification } from "@/hooks/notifications";
import router from "@/router";
import useScorecardsStore from "@/stores/scorecards";

import IconPercentage from "@/components/icons/IconPercentage.vue";

import type { PropType } from "vue";

const props = defineProps({
  applicationIds: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const emit = defineEmits<{
  "report:redirect": [];
}>();

const { showMessage } = useNotification();
const store = useScorecardsStore();
const { t } = useI18n();

const redirectToBacktestReport = () => {
  if (!props.applicationIds.length) {
    showMessage(t("COMMON.SELECT_AT_LEAST_ONE_CHECKBOX"), "warning");
    return;
  }
  emit("report:redirect");
  store.backtestReportApplicationIds = props.applicationIds;
  router.push({
    name: "ScorecardsBacktestReportNew",
    query: { backTo: "Deals" },
  });
};
</script>
